const questionnaires = {
  permissionSource: 'api::questionnaire.questionnaire',
  creationTitle: 'Create Questionnaire',
  creationEndPoint: '/questionnaires',
  detailTitle: 'Questionnaire: :title',
  detailEndPoint: '/questionnaires/:id?populate[0]=clients&populate[1]=members',
  detail: [
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Code',
          value: 'code',
          tag: 'input',
          type: 'text',
          placeholder: 'Questionnaire Code',
          required: true,
        },
        {
          label: 'Description',
          value: 'description',
          tag: 'richTextarea',
          placeholder: 'Questionnaire Description',
        },
      ],
    },
    {
      label: 'Job Progress',
      value: 'job_progress',
      tag: 'input',
      type: 'number',
      placeholder: 'Job Progress',
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Clients',
          value: 'clients',
          tag: 'multi-select',
          dataSourceUrl: '/clients',
          dataLabel: 'name',
          required: false,
        },
        {
          label: 'Members',
          value: 'members',
          tag: 'multi-select',
          dataSourceUrl: '/staffs',
          dataLabel: 'name',
          required: false,
        },
      ],
    },
  ],
  creationData: {},
}
export default questionnaires
